import React, { cloneElement, createContext, useContext, useState } from "react"
import { createPortal } from "react-dom"
import {  Modal as ModalUI, IconButton } from "@material-ui/core"
import PropTypes from 'prop-types';
export const ModalContext = createContext()

function Modal({children}) {
    const [openName, setOpenName] = useState('')
    const close = ()=> setOpenName("")
    const open = setOpenName
    return (
        <ModalContext.Provider value={{openName, close, open}}>
            {children}    
        </ModalContext.Provider>
    )
}
function Open ({children, opens:opensWindowName}){ 
    const {open} = useContext(ModalContext)
    return cloneElement(children, {onClick: ()=> open(opensWindowName)})
}

function Window({children, name}){
    const {openName, close} = useContext(ModalContext)
    if (openName !== name) return null
    return createPortal (
        <ModalUI open={true}>
            <div className="custom-modal-position p-4">
                <IconButton
                    style={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                    }}
                    onClick={close}
                    >
                    <i className="far fa-times-circle "></i>
                </IconButton>
                <div>
                    {cloneElement(children, {onClose:close})}
                </div>
            </div>
        </ModalUI>,
        document.body
    )
}

Modal.Open = Open
Modal.Window = Window

Modal.propTypes = {
    children: PropTypes.any
}
Window.propTypes = {
    children: PropTypes.any,
    name: PropTypes.string
}
export default Modal
